import * as React from 'react';
import { Page } from '../page';
import { TitledBlock } from '../../components/blocks/titledBlock/titledBlock';
import { Button } from '../../components/buttons/button';
import { Row } from '../../components/blocks/ticketBlock/ticketBlock.styles';
import { PayButton, AutopayButton, BoldText, BigGreenText, DueDateText, Transactions, HeaderText, TransactionText, TransactionAmount } from './home.styles';

export class HomePage extends React.Component<{}, {}> {
  public render() {
    return (
      <Page title='Home' tabNavigation={true}>
        <TitledBlock title='Account Summary'>
          <Row style={{justifyContent: 'space-between'}}>
            <div style={{paddingRight: 10, textAlign: 'center'}}>
              <BoldText>Your current balance is</BoldText>
              <BigGreenText>$1,250.00</BigGreenText>
              <DueDateText>Due in 2 days (3/15/2018)</DueDateText>
            </div>
            <div>
              <PayButton>Pay Now</PayButton>
              <AutopayButton>Set Up Autopay</AutopayButton>
            </div>
          </Row>
        </TitledBlock>
        <TitledBlock title='Lease Summary'>
          <Row>
            <BoldText style={{flex: 2}}>Your lease expires on: </BoldText><BigGreenText>12/31/2018</BigGreenText>
          </Row>
          <Row>
            <BoldText style={{flex: 2}}>Your monthly rent is: </BoldText><BigGreenText>$1,200.00</BigGreenText>
          </Row>
        </TitledBlock>
        <TitledBlock title='Transaction History'>
          <Transactions>
            <Row>
              <HeaderText single indent>Date</HeaderText>
              <HeaderText indent>Description</HeaderText>
              <HeaderText single>Amount</HeaderText>
            </Row>
            <Row>
              <TransactionText single>1/1/2018</TransactionText>
              <TransactionText>Payment - Thank you</TransactionText>
              <TransactionAmount single>$1,200.00</TransactionAmount>
            </Row>
            <Row>
              <TransactionText single>12/31/2017</TransactionText>
              <TransactionText>Rent Charge</TransactionText>
              <TransactionAmount single negative>$1,200.00</TransactionAmount>
            </Row>
            <Row>
              <TransactionText single>11/28/2017</TransactionText>
              <TransactionText>Rent Charge</TransactionText>
              <TransactionAmount single negative>$1,200.00</TransactionAmount>
            </Row>
          </Transactions>
        </TitledBlock>
      </Page>
    );
  }
}
